import { render, staticRenderFns } from "./chooseProduct.vue?vue&type=template&id=3c887654"
import script from "./chooseProduct.vue?vue&type=script&lang=js"
export * from "./chooseProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports